<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-child'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isContentEmpty">滞在先苦手な子供の年代</v-list-item-subtitle>
      <v-list-item-title v-if="isContentEmpty">滞在先家庭の子供についての回答</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getContentItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="printNote">{{ printNote }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <span class="caption">苦手な年代を選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.content">
          <v-chip
            v-for="item in getAgeItems"
            :key="`kids_content_${item}`"
            :value="item">{{ item }}</v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.note"
          label="備考欄"
          counter="50"
          :rules="rules.note"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsHomestayKids',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'kids',
        datepicker: {
          publish: false,
          expire: false
        }
      },
      meta: {
        ages: [
          '0歳〜5歳',
          '6歳〜10歳',
          '11歳〜15歳',
          '16歳以上',
          'どの年代でも大丈夫'
        ]
      },
      form: {
        id: '',
        content: '',
        note: ''
      },
      rules: {
        content: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: `${dt.id || ''}`,
          content: dt.content ? dt.content.split(',') : [],
          note: dt.note || ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: `${this.$props.data.id || ''}`,
          content: this.$props.data.content ? this.$props.data.content.split(',') : [],
          note: this.$props.data.note || ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: this.config.type
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.config.type)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.config.type
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.config.type
      )
    },
    getAgeItems () {
      return this.meta.ages
    },
    getContentItems () {
      return (
        this.$props.data &&
        this.$props.data.content
      ) ? this.$props.data.content.split(',') : []
    },
    isContentEmpty () {
      return !(this.$props.data && this.$props.data.content)
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.note
      )
    }
  }
}
</script>
